module.exports = __webpack_public_path__ + "img/video-off.c71afb74.svg";